import http from '../../../utils/fetch';
export default {
    queryOrderList(q) {
        return http({
            url: '/api/swyl/v1/demo/viewOrder/byCreditSelectPage',
            method: 'post',
            params: q
        });
    },
    queryCreditList(q) {
        return http({
            url: '/api/swyl/v1/infoCredit/userInfoCredit/queryCreditPage',
            method: 'post',
            params: q
        });
    },
    xiugaiDate(q) {
        return http({
            url: '/api/swyl/v1/infoCredit/userInfoCredit/xiugaiDate',
            method: 'post',
            params: q
        });
    },
    exportExeal(q) {
        return http({
            url: '/api/swyl/v1/infoCredit/userInfoCredit/downloadExcel',
            method: 'get',
            params: q
        });
    },
    querybackList(q) {
        return http({
            url: '/api/swyl/v1/demo/viewOrderMoneyBack//selectPage',
            method: 'post',
            params: q
        });
    },
	querybackListWx(q) {
	    return http({
	        url: '/api/swyl/v1/demo/viewOrderMoneyBack//selectWxPage',
	        method: 'post',
	        params: q
	    });
	},
    querybackListWxWkp(q) {
        return http({
            url: '/api/swyl/v1/demo/viewOrderMoneyBack/selectWxWkpPage',
            method: 'post',
            params: q
        });
    },
    queryYsSelectPage(q) {
        return http({
            url: '/api/swyl/v1/infoCredit/OrderMoneyBackWxWkpFp/selectPage',
            method: 'post',
            params: q
        });
    },
    queryYsNxfSelectPage(q) {
        return http({
            url: '/api/swyl/v1/infoCredit/OrderMoneyBackWxWkpFp//selectNxfPage',
            method: 'post',
            params: q
        });
    },
    queryYsSelectNxPage(q) {
        return http({
            url: '/api/swyl/v1/infoCredit/OrderMoneyBackWxWkpFp/selectNxPage',
            method: 'post',
            params: q
        });
    },
	querybackListSh(q) {
	    return http({
	        url: '/api/swyl/v1/demo/viewOrderMoneyBack//selectShPage',
	        method: 'post',
	        params: q
	    });
	},

    querytuishuiList(q) {
        return http({
            url: '/api/swyl/v1/demo/viewOrderMoneyTuishui/selectPage',
            method: 'post',
            params: q
        });
    },
    querytuishuiHistoryList(q) {
        return http({
            url: '/api/swyl/v1/demo/viewOrderMoneyTuishui/selectHistoryPage',
            method: 'post',
            params: q
        });
    },
	getCreditComparePage(q) {
		return http({
		    url: '/api/swyl/v1/infoCredit/userInfoCredit/getCreditComparePage',
		    method: 'post',
		    params: q
		});
	},
	querySapAccount(q){
		return http({
		    url: '/api/swyl/v1/chengben/sapzxdswylaccount/querySapAccountPage',
		    method: 'post',
		    params: q
		});
	},
	synSapHistory(q){
		return http({
			url: '/api/swyl/v1/chengben/sapzxdswylaccount/synSapHistory',
			method: 'post',
			params: q
		});
	},
    queryYsDaySelectPage(q) {
        return http({
            url: '/api/swyl/v1/infoCredit/OrderMoneyBackWxWkpFp/selectDayPage',
            method: 'post',
            params: q
        });
    },
    queryYsSelectNxDayPage(q) {
        return http({
            url: '/api/swyl/v1/infoCredit/OrderMoneyBackWxWkpFp/selectNxDayPage',
            method: 'post',
            params: q
        });
    },
}